import '../polyfills/closest';
import 'performance-polyfill';
import smoothscroll from 'smoothscroll-polyfill';
import requestAnimationFrame from './requestAnimationFrame';
import getPerformanceNow from './performance';

smoothscroll.polyfill();

export const SCROLL_DURATION = 750;
export const SCROLL_TOP = 0;

/**
 * 
 * Scrolls to a given offset from the top of an element,
 * or to top if element is inside of a modal.
 * @param {DOM Element} el 
 */
export default function scrollToElement(el, offset = 0){
  if(isInsideModal(el)) {
    el.scrollIntoView({ behavior: 'smooth' });
    return;
  }
  
  const boundingBox = el.getBoundingClientRect();
  const top = boundingBox.top;
  const scrollToY = top + offset + getScrollPosition();
  scrollToPosition(scrollToY);
}

export function getScrollPosition() {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
}

function isInsideModal(el) {
  return !!el.closest('.modal');
}

function scrollToPosition(y = SCROLL_TOP, duration = SCROLL_DURATION, callback) {
  const initialY = getScrollPosition(),
        baseY = (initialY + y) * 0.5,
        difference = initialY - baseY,
        startTime = getPerformanceNow();

  function step() {
    const now = getPerformanceNow();
    const normalizedTime = Math.min(parseFloat(now - startTime) / duration, 1);

    window.scrollTo(0, baseY + difference * Math.cos(normalizedTime * Math.PI));

    if (normalizedTime < 1) {
      requestAnimationFrame(step);
    } else {
      callback && callback();
    }
  }

  requestAnimationFrame(step);
}



// WEBPACK FOOTER //
// ./client/app/scripts/principles/animations/scrollTo.js